export const m = {
  EnterID: "点击输入 Tada ID",
  "select-specifications": "点击选择充值规格",
  "check-account": "核对充值账号",
  whatID: "什么是 Tada ID ？",
  getID: "输入 Tada ID",
  maskgetID: "输入 Tada ID",
  "toastTips-format-error": "输入格式有误",
  "toastTips-no-exist": "该ID不存在",
  toastTipsPlease: "请先核对充值账号",
  "common-problem": "常见问题",
  "transaction-succeeded": "交易成功",
  "transaction-failed": "交易失败",
  "transaction-cancel": "交易取消",
  "whether-account": "1.我充值后怎么查看是否到账？",
  "answer-whether-account": "充值后可回到 APP 的【我的】-【钱包】中查看钻石",
  "no-account": "2.充值后若是没有到账怎么办？",
  "answer-no-account":
    "请在 APP 的【消息】-【官方消息】-【反馈与帮助】中提交您的问题，并提供以下信息，我们的客服将为您提供帮助。",
  "recharge-money": "1.充值金额和账户 ID",
  "recharge-time": "2.充值的时间和日期",
  "recharge-shot": "3.支付成功的屏幕截图",
  "recharge-wrong": "3.充错账户，充错金额怎么办",
  "answer-recharge-wrong":
    "请您在输入支付密码前，务必仔细确认充值账户 ID 和充值金额信息后再进行购买。错充金额无法退还，错充账户您可尝试与实际充值的 ID 用户联系，与对方协商是否愿意补偿您的充值。",
  refund: "4.退款",
  "answer-refund": "抱歉！Tada 目前不支持任何形式的退款。",
  "buy-enter-link":
    '购买钻石可通过链接进行充值，<a class="web-link" href="http://pay.tadachat.live/" >http://pay.tadachat.live</a> 将链接复制在手机浏览器中打开，进入购买页面，核对账号后，选择相应的规格并使用合适的支付方式进行支付即可～ 优惠多多！',
  "buy-notice-a": "注意: <a>pay.tadachat.live</a> 是 Tada 唯一官方购买钻石网址",
  replace: "更换",
  sureBtn: "确定",
  "pay-style": "选择支付方式",
  goBack: "回到首页",
  toastTips: "输入 Tada ID",
  rechargeFAQ_title: "常见问题",
  PayStatusSuccess_title: "交易成功",
  PayStatusFail_title: "交易失败",
  PayStatusCancel_title: "交易取消",
  Diamonds_title: "Tada 钻石充值官方网站",
  "buy-notice":
    "注意  pay.Tadachat.live 是 Tada 唯一官方购买钻石网站，客服咨询请进入【消息】-【官方消息】-【反馈与帮助】",
  RechargeHelp_title: "充值帮助",
  openAPP: "打开 Tada APP",
  "buy-diamonds-tit": "购买钻石服务",
  description:
    "Tada 唯一官方钻石充值网站 ， Tada 是一款国际化社交软件，全球超过150多个国家和地区的用户正在使用 Tada",
  keywords: "Tada 充值,Tada 钻石充值,Tada 官方充值,Tada 官方充值网站",
  wxPay: "请确认微信支付是否已完成",
  Completed: "已完成支付",
  failedPay: "支付遇到问题,重新支付",
  "toastTips-no-complete": "支付未完成，请重新支付",
  payforType: "充值方式",
  trueText: "确定",
  falseText: "取消",
  alertShowTxt1: "确定用",
  alertShowTxt3: "充值",
  alertShowTxt5: "钻石？",
  EnterIDTip: " Tada快速充值",
  scanLogin: " 为了账户隐私和安全，请扫码登录",
  scanTip:
    " 提示：点击 Tada “个人中心/动态”右上角“扫一扫”扫码登录，同时支持识别二维码截图的方式登录",
  scanVersion: " 请升级 Tada 到 %s 版本后扫码登录",
  delAccount: " 账号删除",
  logout: " 退出",
  submit: "提交",
  email_place_holder: "请输入您的邮箱地址",
  contact_email: "联系邮箱",
  provide_email: "请提供您的电子邮箱来接收付款通知",
  email_address: "电子邮箱地址",
};



// WEBPACK FOOTER //
// ./src/lang/zh.js